/************
 * Service Class
 * File Name ...: messages.service.ts
 * Generated By : ianday on 1/9/24
 * Date ........: 1/9/24
 /************/
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { MessageDefinition } from "../models/message-definition";
import { Settings } from './settings';
import { MessageToken } from "../models/message-token";
import { MessagesSent } from "../models/messages-sent";
import { MailOption } from "../models/mail-option";
import { MessageSuffix } from '../models/message-suffix';

@Injectable({
	providedIn: 'root'
})
export class MessageDefinitionService {

	public URLMessageDefsPath: string = Settings.getInstance().BASE_URL + 'messages/message-defs/';
	public URLMessageTokensPath: string = Settings.getInstance().BASE_URL + 'messages/message-tokens/';
	public URLMessagesSentPath: string = Settings.getInstance().BASE_URL + 'messages/messages-sent/';
	public URLMessageSendPath: string = Settings.getInstance().BASE_URL + 'messages/message-send/';
	public URLApplicationEventsPath: string = Settings.getInstance().BASE_URL + 'messages/application-events/';
	public URLMessageEventsPath: string = Settings.getInstance().BASE_URL + 'messages/message-events/';
	public URLMessageSuffixPath: string = Settings.getInstance().BASE_URL + 'messages/message-suffixes/';


	constructor(private http: HttpClient) {
	}
	/** message definitions **/
	public getAllMessageDefinitions(): Observable<any> {
		return this.http.get<any>(this.URLMessageDefsPath)
			.pipe(
				retry(1)
			);
	}
	public getAllActiveMessageDefinitions(): Observable<any> {
		return this.http.get<any>(this.URLMessageDefsPath + 'active/')
			.pipe(
				retry(1)
			);
	}
	public createMessageDefinition(record: MessageDefinition): Observable<any> {
		return this.http.post(this.URLMessageDefsPath, record)
			.pipe(
				retry(1)
			);
	}
	public uploadMessageDefinitionFile(id: any, fileTemplate: File): Observable<any> {
		const formData: FormData = new FormData();
		formData.append('messagedefinition', fileTemplate, fileTemplate.name);
		return this.http.post<any>(this.URLMessageDefsPath + 'file/' + id, formData)
			.pipe(
				retry(0)
			);
	}
	public updateMessageDefinition(record: MessageDefinition): Observable<any> {
		return this.http.put(this.URLMessageDefsPath + record.id, record)
			.pipe(
				retry(1)
			);
	}
	public deleteMessageDefinition(id: number): Observable<any> {
		return this.http.delete(this.URLMessageDefsPath + id)
			.pipe(
				retry(1)
			);
	}
	/** message tokens **/
	public getAllMessageTokens(): Observable<any> {
		return this.http.get<any>(this.URLMessageTokensPath)
			.pipe(
				retry(1)
			);
	}
	public getMessageDefinitionByEventCode(evCode: string): Observable<any> {
		return this.http.get<any>(this.URLMessageEventsPath + evCode)
			.pipe(
				retry(1)
			);
	}
	public createMessageToken(record: MessageToken): Observable<any> {
		return this.http.post(this.URLMessageTokensPath, record)
			.pipe(
				retry(1)
			);
	}
	public updateMessageToken(record: MessageToken): Observable<any> {
		return this.http.put(this.URLMessageTokensPath + record.id, record)
			.pipe(
				retry(1)
			);
	}
	public deleteMessageToken(id: number): Observable<any> {
		return this.http.delete(this.URLMessageTokensPath + '/' + id)
			.pipe(
				retry(1)
			);
	}
	/** message send **/
	public sendMessage(record: MailOption): Observable<any> {
		return this.http.post(this.URLMessageSendPath, record)
			.pipe(
				retry(1)
			);
	}

	/*** messages sent **/
	public getMessagesSentByFKey(foreignKeyTable: string, foreignKeyId: number, restrictedAgencyFlag?: boolean): Observable<any> {
		return this.http.get<any>(
			this.URLMessagesSentPath + foreignKeyTable + '/' + foreignKeyId + (restrictedAgencyFlag ? '/true' : '')
		).pipe(retry(1));
	}

	public createMessageSent(record: MessagesSent): Observable<any> {
		return this.http.post(this.URLMessagesSentPath, record)
			.pipe(
				retry(1)
			);
	}
	public getAllActiveApplicationEvents(): Observable<any> {
		return this.http.get<any>(this.URLApplicationEventsPath + '/active')
			.pipe(
				retry(1)
			);
	}
	public getAllApplicationEvents(): Observable<any> {
		return this.http.get<any>(this.URLApplicationEventsPath)
			.pipe(
				retry(1)
			);
	}

	public updateApplicationEvent(appEvent: any): Observable<any> {
		return this.http.put<any>(this.URLApplicationEventsPath, appEvent)
			.pipe(
				retry(1)
			);
	}
	public getAllMessageEvents(): Observable<any> {
		return this.http.get<any>(this.URLMessageEventsPath)
			.pipe(
				retry(1)
			);
	}
	public updateMessageEvent(appEventId: number, messageId: number): Observable<any> {
		return this.http.put<any>(this.URLMessageEventsPath + appEventId + '/' + messageId, {})
			.pipe(
				retry(1)
			);
	}

	/** Email Suffixes **/
	public getAllMessageSuffixes(): Observable<any> {
		return this.http.get<any>(this.URLMessageSuffixPath)
			.pipe(
				retry(1)
			);
	}

	public getMessageSuffixById(id: number): Observable<any> {
		return this.http.get<any>(this.URLMessageSuffixPath + id)
			.pipe(
				retry(1)
			);
	}

	public getMessageSuffixByServiceDefIdAndRequestStatusId(serviceDefId: number, serviceStatusId: number): Observable<any> {
		return this.http.get<any>(this.URLMessageSuffixPath + serviceDefId + '/' + serviceStatusId)
			.pipe(
				retry(1)
			);
	}

	public createMessageSuffix(record: MessageSuffix): Observable<any> {
		return this.http.post(this.URLMessageSuffixPath, record)
			.pipe(
				retry(1)
			);
	}

	public updateMessageSuffix(record: MessageSuffix): Observable<any> {
		return this.http.put(this.URLMessageSuffixPath + record.id, record)
			.pipe(
				retry(1)
			);
	}

	public deleteMessageSuffix(id: number): Observable<any> {
		return this.http.delete(this.URLMessageSuffixPath + id)
			.pipe(
				retry(1)
			);
	}
}
